const { getElements } = window.BAO.Utils
const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class DeviceSelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousels()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== triggerEl.dataset.tab,
      )
    })
    this.els.trigger.elements.forEach(trigger => {
      trigger.setAttribute(
        'aria-pressed',
        trigger.dataset.tab === triggerEl.dataset.tab,
      )
    })

    this.setupCarousels()
  }

  setupCarousels () {
    this.els.slides.elements.forEach(slidesEl => {
      const slidesCount = getElements('[data-collab-selector-el="slide"]', {
        context: slidesEl,
      }).length

      if (window.innerWidth >= 901 && slidesCount < 7) {
        slidesEl.classList.add(this.dataset.notFullClass)
      } else if (window.innerWidth >= 768 && slidesCount < 5) {
        slidesEl.classList.add(this.dataset.notFullClass)
      }

      return new KeenSlider(
        slidesEl,
        {
          selector: '.keen-slider__slide',
          loop: true,
          mode: 'snap',
          rubberband: false,
          slides: {
            perView: 3.5,
            spacing: 5,
          },
          breakpoints: {
            '(min-width: 768px)': {
              slides: {
                perView: 5,
                spacing: 0,
              },
            },
            '(min-width: 901px)': {
              slides: {
                perView: 7,
              },
            },
          },
        },
        [
          setInitialised(),
          useArrows({
            container: slidesEl.querySelector(
              '[data-collab-selector-el="arrows"]',
            ),
            next: slidesEl.querySelector('[data-collab-selector-el="next"]'),
            previous: slidesEl.querySelector(
              '[data-collab-selector-el="previous"]',
            ),
          }),
        ],
      )
    })
  }
}

if (!customElements.get('collab-selector')) {
  customElements.define('collab-selector', DeviceSelector)
}
